import React, { useMemo } from 'react';
import { formatNumberWithTwoDecimals, getNumericValue } from '@Shared/Utils';

const sumField = (items, fieldName) => {
    return items.reduce((acc, item) => acc + getNumericValue(item?.[fieldName]), 0);
};

const TotalesPago = ({ items }) => {
    const sourceItems = useMemo(() => Array.isArray(items.data) ? items.data : [], [items]);

    const formatCurrency = (value) => `$ ${formatNumberWithTwoDecimals(getNumericValue(value))}`;

    const totalAcumulado = useMemo(() => {
        return sumField(sourceItems, 'totalBR');
    }, [sourceItems]);

    const ganancias = useMemo(() => {
        return items.ganancias ? getNumericValue(items.ganancias) : 0;
    }, [sourceItems]);

    const ibOsMunicip = useMemo(() => {
        return items.ibOsMunicip ? getNumericValue(items.ibOsMunicip) : 0;
    }, [sourceItems]);

    const importePagado = useMemo(() => {
        return totalAcumulado - ganancias - ibOsMunicip;
    }, [totalAcumulado, ganancias, ibOsMunicip]);

    return (
        <div className="totales-pago-container">
            <div className='sumatoriaPagos'>
                <div className="sumatoria-content">
                    <b>
                        <i className="bi bi-calculator icon"></i>
                        TOTAL ACUMULADO
                    </b>
                    <p>{formatCurrency(totalAcumulado)}</p>
                </div>
            </div>

            <div className='sumatoriaPagos'>
                <div className="sumatoria-content">
                    <b>
                        <i className="bi bi-building icon"></i>
                        Retención IB-OS-Municipal
                    </b>
                    <p>{formatCurrency(ibOsMunicip)}</p>
                </div>
            </div>

            <div className='sumatoriaPagos'>
                <div className="sumatoria-content">
                    <b>
                        <i className="bi bi-currency-dollar icon"></i>
                        Retención Ganancias
                    </b>
                    <p>{formatCurrency(ganancias)}</p>
                </div>
            </div>

            <div className='sumatoriaPagos'>
                <div className="sumatoria-content">
                    <b>
                        <i className="bi bi-check-circle icon"></i>
                        TOTAL PAGADO
                    </b>
                    <p>{formatCurrency(importePagado)}</p>
                </div>
            </div>
        </div>
    );
};

export default TotalesPago;
